module.exports = __webpack_public_path__ + "img/bg.1c285936.png";